import { useMutation } from "react-query";

import { httpService } from "utils";
import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

export const useEditAppointment = (intervalId: number, tokenId: string) => {
  const { friendlyUrl } = useGetFriendlyUrl();

  return useMutation((data: FormData) => {
    return editAppointment(data, friendlyUrl, tokenId, intervalId);
  });
};

const editAppointment = (
  formData: FormData,
  friendlyUrl: string,
  tokenId: string,
  intervalId: number
) => {
  return httpService().post(
    `/e-reservation/${friendlyUrl}/appointment/edit/${tokenId}/${intervalId}`,
    formData
  );
};
